export default __webpack_public_path__ + "static/media/loudspeaker-1.7b9fb06c.png";